/*
 * Customaly product page behaviour. Original work.
 *
 * Two things Dawn's product template does not do on its own:
 *   1. arrows over the main image (Dawn only ships slider buttons for the
 *      mobile carousel), and
 *   2. a styleable dropdown for the variant picker.
 *
 * Both lean on markup Dawn already renders, so the cart form, the media
 * gallery and the section-rendering API keep working untouched.
 */
(function () {
  /* Gallery arrows --------------------------------------------------------- */
  /* On desktop every media item but the active one is display:none, so the
     slider cannot be scrolled. Clicking the neighbouring thumbnail runs Dawn's
     own setActiveMedia, which is exactly what the arrows should do. */

  function stepGallery(gallery, step) {
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item button')
    )

    if (thumbs.length < 2) {
      return
    }

    var current = thumbs.findIndex(function (button) {
      return button.getAttribute('aria-current') === 'true'
    })

    if (current < 0) {
      current = 0
    }

    var next = (current + step + thumbs.length) % thumbs.length

    thumbs[next].click()

    /* The rail is capped at the image height and scrolls, so centre the new
       active thumb in it. Doing the maths by hand rather than scrollIntoView
       keeps the page itself from scrolling. */
    var rail = thumbs[next].closest('.thumbnail-slider')

    if (rail) {
      var thumbRect = thumbs[next].getBoundingClientRect()
      var railRect = rail.getBoundingClientRect()

      rail.scrollTop +=
        thumbRect.top - railRect.top - (railRect.height - thumbRect.height) / 2
    }
  }

  function initializeGalleryArrows(scope) {
    scope.querySelectorAll('[data-cu-gallery-step]').forEach(function (button) {
      if (button.getAttribute('data-cu-gallery-ready') === 'true') {
        return
      }

      button.setAttribute('data-cu-gallery-ready', 'true')

      button.addEventListener('click', function () {
        var gallery = button.closest('media-gallery')

        if (gallery) {
          stepGallery(gallery, parseInt(button.getAttribute('data-cu-gallery-step'), 10))
        }
      })
    })
  }

  /* Variant dropdown ------------------------------------------------------- */

  function syncDropdown(wrapper) {
    var select = wrapper.querySelector('select')
    var value = wrapper.querySelector('.cu-variant-select__value')

    if (!select) {
      return
    }

    if (value) {
      value.textContent = select.selectedOptions[0] ? select.selectedOptions[0].text : ''
    }

    wrapper.querySelectorAll('.cu-variant-select__option').forEach(function (option) {
      var native = Array.prototype.find.call(select.options, function (item) {
        return item.value === option.getAttribute('data-value')
      })
      var selected = !!native && native.selected
      var disabled = !!native && native.disabled

      option.disabled = disabled
      option.setAttribute('aria-disabled', String(disabled))
      option.setAttribute('aria-selected', String(selected))
      option.classList.toggle('is-selected', selected)
    })
  }

  function closeDropdown(wrapper, restoreFocus) {
    var trigger = wrapper.querySelector('.cu-variant-select__trigger')

    wrapper.classList.remove('is-open', 'opens-upward')

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false')

      if (restoreFocus) {
        trigger.focus()
      }
    }
  }

  function closeAllDropdowns(except) {
    document.querySelectorAll('.product-form__input--dropdown.is-open').forEach(function (wrapper) {
      if (wrapper !== except) {
        closeDropdown(wrapper)
      }
    })
  }

  function openDropdown(wrapper) {
    var trigger = wrapper.querySelector('.cu-variant-select__trigger')
    var listbox = wrapper.querySelector('.cu-variant-select__listbox')

    if (!trigger || !listbox) {
      return
    }

    closeAllDropdowns(wrapper)

    var rect = trigger.getBoundingClientRect()
    var below = window.innerHeight - rect.bottom - 16
    var above = rect.top - 16

    wrapper.classList.toggle('opens-upward', below < Math.min(listbox.scrollHeight, 280) && above > below)
    wrapper.classList.add('is-open')
    trigger.setAttribute('aria-expanded', 'true')
  }

  function focusOption(option) {
    if (!option) {
      return
    }

    option.parentNode.querySelectorAll('.cu-variant-select__option').forEach(function (item) {
      item.tabIndex = item === option ? 0 : -1
    })

    option.focus()
  }

  function enabledOptions(wrapper) {
    return Array.prototype.slice.call(
      wrapper.querySelectorAll('.cu-variant-select__option:not(:disabled)')
    )
  }

  function enhanceDropdown(wrapper) {
    var select = wrapper.querySelector('select')

    /* Swatch dropdowns render a colour chip Dawn owns; leave those native. */
    if (!select || wrapper.querySelector('.dropdown-swatch')) {
      return
    }

    var triggerId = select.id + '-cu-trigger'
    var listboxId = select.id + '-cu-listbox'
    var valueId = select.id + '-cu-value'
    var trigger = document.createElement('button')
    var value = document.createElement('span')
    var chevron = document.createElement('span')
    var listbox = document.createElement('div')

    trigger.type = 'button'
    trigger.id = triggerId
    trigger.className = 'cu-variant-select__trigger'
    trigger.setAttribute('aria-haspopup', 'listbox')
    trigger.setAttribute('aria-expanded', 'false')
    trigger.setAttribute('aria-controls', listboxId)

    value.className = 'cu-variant-select__value'
    value.id = valueId
    chevron.className = 'cu-variant-select__chevron'
    chevron.setAttribute('aria-hidden', 'true')
    trigger.append(value, chevron)

    listbox.id = listboxId
    listbox.className = 'cu-variant-select__listbox'
    listbox.setAttribute('role', 'listbox')

    Array.prototype.forEach.call(select.options, function (option) {
      var button = document.createElement('button')
      var label = document.createElement('span')
      var check = document.createElement('span')

      button.type = 'button'
      button.className = 'cu-variant-select__option'
      button.setAttribute('data-value', option.value)
      button.setAttribute('role', 'option')
      button.tabIndex = -1

      label.className = 'cu-variant-select__option-label'
      label.textContent = option.text
      check.className = 'cu-variant-select__checkmark'
      check.setAttribute('aria-hidden', 'true')
      button.append(label, check)

      button.addEventListener('click', function () {
        if (select.value !== option.value) {
          select.value = option.value
          select.dispatchEvent(new Event('change', { bubbles: true }))
        }

        closeDropdown(wrapper, true)
      })

      button.addEventListener('keydown', function (event) {
        var options = enabledOptions(wrapper)
        var index = options.indexOf(button)

        if (event.key === 'Escape' || event.key === 'Tab') {
          closeDropdown(wrapper, event.key === 'Escape')
          return
        }

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          button.click()
          return
        }

        if (event.key === 'ArrowDown') {
          index = (index + 1) % options.length
        } else if (event.key === 'ArrowUp') {
          index = (index - 1 + options.length) % options.length
        } else if (event.key === 'Home') {
          index = 0
        } else if (event.key === 'End') {
          index = options.length - 1
        } else {
          return
        }

        event.preventDefault()
        focusOption(options[index])
      })

      listbox.append(button)
    })

    var label = wrapper.querySelector('.form__label')

    if (label) {
      label.id = label.id || select.id + '-cu-label'
      label.setAttribute('for', triggerId)
      trigger.setAttribute('aria-labelledby', label.id + ' ' + valueId)
      listbox.setAttribute('aria-labelledby', label.id)
    } else {
      listbox.setAttribute('aria-labelledby', triggerId)
    }

    trigger.addEventListener('click', function () {
      if (wrapper.classList.contains('is-open')) {
        closeDropdown(wrapper)
      } else {
        openDropdown(wrapper)
      }
    })

    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDropdown(wrapper)
        return
      }

      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) < 0) {
        return
      }

      event.preventDefault()
      openDropdown(wrapper)

      var options = enabledOptions(wrapper)
      focusOption(event.key === 'ArrowUp' || event.key === 'End' ? options[options.length - 1] : options[0])
    })

    select.addEventListener('change', function () {
      syncDropdown(wrapper)
    })

    wrapper.append(trigger, listbox)
    wrapper.classList.add('is-cu-enhanced')
    syncDropdown(wrapper)
  }

  function initializeDropdowns(scope) {
    scope.querySelectorAll('.product-form__input--dropdown').forEach(function (wrapper) {
      if (!wrapper.classList.contains('is-cu-enhanced')) {
        enhanceDropdown(wrapper)
      }
    })
  }

  /* Wiring ----------------------------------------------------------------- */
  /* Dawn replaces the whole <variant-selects> element on every variant change,
     so the enhancement has to be re-applied to the new markup. */

  function observe(productInfo) {
    if (productInfo.getAttribute('data-cu-product-observed') === 'true') {
      return
    }

    productInfo.setAttribute('data-cu-product-observed', 'true')

    new MutationObserver(function () {
      initializeDropdowns(productInfo)
      initializeGalleryArrows(productInfo)
    }).observe(productInfo, { childList: true, subtree: true })
  }

  function initializeAll(scope) {
    initializeDropdowns(scope)
    initializeGalleryArrows(scope)
    scope.querySelectorAll('product-info').forEach(observe)
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.product-form__input--dropdown')) {
      closeAllDropdowns()
    }
  })

  window.addEventListener('resize', function () {
    closeAllDropdowns()
  }, { passive: true })

  document.addEventListener('DOMContentLoaded', function () {
    initializeAll(document)
  })

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target)
  })
})()
